import axiosInstance from "./auth";

export const getAllReferrals = async (
  page = 1,
  limit = 10,
  name = "",
  email = "",
) => {
  try {
    let url = `/referral/admin/referred?limit=${limit}&page=${page}`;

    if (name && name.trim() !== "") {
      url += `&name=${encodeURIComponent(name)}`;
    }

    if (email && email.trim() !== "") {
      url += `&email=${encodeURIComponent(email)}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getAllReferralCodes = async (
  page = 1,
  limit = 10,
  code = null,
  startDate = null,
  endDate = null,
) => {
  try {
    const params = {
      limit,
      page,
    };

    if (code && code.trim()) {
      params.code = code;
    }

    if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/referral/admin/list", {
      params,
    });

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const CreateReferral = async (data = { type: "default" }) => {
  try {
    const response = await axiosInstance.post(
      "/referral/track/registration",
      data,
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const changeReferral = async (data) => {
  try {
    const response = await axiosInstance.patch(
      "/referral/admin/change-user-referrer",
      data,
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const removeUserReferrer = async (data) => {
  try {
    const response = await axiosInstance.patch(
      "/referral/admin/remove-user-referrer",
      data,
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
